import Decimal from 'decimal.js';

export function allocateReminderAmounts(totalAmount, percentages = []) {
  const normalizedPercentages = Array.isArray(percentages) ? percentages : [];

  if (!normalizedPercentages.length) {
    return [];
  }

  const total = new Decimal(totalAmount || 0);
  let allocatedAmount = new Decimal(0);

  return normalizedPercentages.map((percentage, index) => {
    const amount = index === normalizedPercentages.length - 1
      ? total.minus(allocatedAmount)
      : total.mul(percentage || 0).div(100).toDecimalPlaces(2, Decimal.ROUND_HALF_UP);

    allocatedAmount = allocatedAmount.plus(amount);
    return amount.toFixed(2);
  });
}
